import { FunctionComponent } from "react";
import { CHEVRON_ORIENTATION_LEFT, ChevronOrientation, IconProps } from "./constants";

import * as Styled from "./styles";

interface ArrorIconProps extends IconProps {
  orienation?: ChevronOrientation;
}

const ArrowIcon: FunctionComponent<ArrorIconProps> = ({
  width = 15,
  height = 13,
  color = "#122A26",
  orienation = CHEVRON_ORIENTATION_LEFT,
  ...props
}: ArrorIconProps) => {
  return (
    <Styled.ArrowIconWrapper
      $orientation={orienation}
      data-name={props.name || "arrow"}
      data-testid={props.name || "arrow"}
    >
      <svg width={width} height={height} viewBox={`0 0 15 13`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.29169 1L1 6.29169M1 6.29169L6.29169 11.5834M1 6.29169L13.7 6.29151"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Styled.ArrowIconWrapper>
  );
};

export default ArrowIcon;
